<template>
  <span
    :class="[
      $style.wrap,
      {
        [$style.center]: center,
        [$style.right]: right,
        [$style.stacked]: stacked,
        [$style.margin]: margin,
        [$style.primaryActions]: primaryActions,
      },
    ]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "ActionList",
  props: {
    center: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: Boolean,
      default: false,
    },
    primaryActions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="module.css" module>
.wrap {
  display: flex;
  align-items: center;
}
.wrap:not(.stacked) > * {
  margin-left: 1rem;
}
.wrap:not(.stacked) > *:first-child {
  margin-left: 0;
}
.wrap.center {
  justify-content: center;
}
.wrap.right {
  justify-content: flex-end;
}
.wrap.stacked {
  flex-direction: column;
}
.wrap.stacked > * {
  margin-top: 1rem;
}
.wrap.stacked > *:first-child {
  margin-top: 0;
}
.wrap > em {
  color: #999;
  margin-left: 2rem;
  margin-right: 2rem;
}
.wrap > em:first-child {
  margin-left: 0;
}
.wrap > em:last-child {
  margin-right: 0;
}
.wrap.stacked > em {
  color: #999;
  margin: 0.5rem 0 -0.5rem;
}
.wrap.stacked > em:last-child {
  margin-bottom: 0;
}
.wrap.margin {
  margin: 2rem 0;
}
.wrap.primaryActions {
  position: fixed;
  z-index: 30;
  justify-content: flex-end;
  bottom: 20px;
  right: 20px;
  left: 20px;
}
</style>
